import { RELATED_MANAGER_FORM_FIELDS } from './form-fields';

export const RELATED_MANAGER_FORM_PATHS = {
  SELECTED_MANAGER: () => RELATED_MANAGER_FORM_FIELDS.SELECTED_MANAGER,
  SELECTED_SECTOR: () => RELATED_MANAGER_FORM_FIELDS.SELECTED_SECTOR,
};
